import { useEffect } from 'react';

import { VARIANT_IDENTIFIER } from '@/modules/experiments/config';
import { useExperiments } from '@/modules/experiments/useExperiments';

export function useFreeShippingMessagingExperiment(isEligible: boolean) {
  const [decisions, bucket] = useExperiments(
    ['web_8765_free_shipping_messaging_us'],
    { deferred: true }
  );

  useEffect(() => {
    if (isEligible) {
      bucket();
    }
  }, [isEligible, bucket]);

  return (
    isEligible &&
    decisions.web_8765_free_shipping_messaging_us === VARIANT_IDENTIFIER
  );
}
